import { Component, Input } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PermittedAccess } from '../../../fleets/models/permitted-access.model';
import { Receiver } from '@features/receivers/models/receiver.model';

@Component({
  selector: 'app-permit-access-control',
  templateUrl: './permit-access-control.component.html',
  styleUrls: ['./permit-access-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PermitAccessControlComponent,
    }
  ]
})
export class PermitAccessControlComponent implements ControlValueAccessor {
  @Input() receivers: Receiver[];
  @Input() columnClass = 'col-12 col-md-4';

  form: FormGroup;
  value: PermittedAccess = {} as PermittedAccess;
  minDate = moment().add(1, 'd');
  destroy$ = new Subject();

  onChange: (v: any) => void;
  onTouched: () => void;

  touched = {
    label: false,
    expirationDate: false,
    receiver: false,
  };

  constructor(private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      label: [''],
      expirationDate: [''],
      receiver: [],
    });

    this.form.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.value = this.form.value;
        this.onChange(this.value);
      });
  }

  handleTouch(key): void {
    let touched = true;
    this.touched[key] = true;
    touched = Object.keys(this.touched).reduce((t, k) => {
      if (!t || !this.touched[k]) {
        return false;
      }
      return t;
    }, true);

    if (touched) {
      this.onTouched();
    }
  }

  writeValue(value: PermittedAccess): void {
    const receiver = value?.receiver ? this.receivers.find((r) => r.id === value.receiver.id) : null;
    const expirationDate = value?.expirationDate ? new Date(value.expirationDate) : null;
    this.value = {...value, receiver, expirationDate};
    this.form.patchValue(this.value, { onlySelf: true, emitEvent: false });
  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
}
